import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { useBuscarVenta } from "../../../services/ventasServicios";
import { useBuscarAgendamientosDeVenta } from "../../../services/agendamientosServicios";
import { Venta } from "../../venta/Venta";
import LoadingScreen from "../../organisms/LoadingScreen";
import ServerErrorModal from "../../organisms/ServerErrorModal";
import PagarModal from "../../pagar/PagarModal";

function DetailSection({
  idVenta,
  onPagoFinalizado,
  onCloseClick,
}: {
  idVenta: string;
  onPagoFinalizado: () => void;
  onCloseClick: () => void;
}) {
  const {
    data: venta,
    isLoading: ventaIsLoading,
    isSuccess: ventaIsSuccess,
    isError: ventaIsError,
  } = useBuscarVenta(idVenta);

  const {
    data: agendamientos,
    isLoading: agendamientosIsLoading,
    isSuccess: agendamientosIsSuccess,
    isError: agendamientosIsError,
  } = useBuscarAgendamientosDeVenta(idVenta, true);

  const [mostrarPagar, setMostrarPagar] = useState<boolean>(false);

  const onPagarClick = () => {
    setMostrarPagar(true);
  };

  const onCerrarPagarClick = () => {
    setMostrarPagar(false);
  };

  if (ventaIsError || agendamientosIsError) {
    return <ServerErrorModal />;
  }

  if (!venta && ventaIsSuccess && !ventaIsLoading) {
    return <ServerErrorModal />;
  }

  if (ventaIsLoading) {
    return <LoadingScreen />;
  }

  return (
    <>
      <section>
        {venta && (
          <Venta
            venta={venta}
            agendamientos={agendamientos}
            agendamientosIsLoading={agendamientosIsLoading}
            agendamientosIsSuccess={agendamientosIsSuccess}
            onPagarClick={onPagarClick}
          />
        )}
        {venta && mostrarPagar && (
          <PagarModal
            venta={venta}
            onRegistrarPago={onPagoFinalizado}
            onCloseClick={onCerrarPagarClick}
          />
        )}
        <section className="d-flex justify-content-end">
          <Button onClick={onCloseClick}>Cerrar</Button>
        </section>
      </section>
    </>
  );
}

export default DetailSection;
